import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import "katex/dist/katex.min.css";

import { createReadOnlyExtensions, parseTiptapContent } from "../../utils/tiptapReadOnly";
import { attachImageFallback } from "../../utils/imageFallback";

/**
 * Rendu en lecture seule d'un document TipTap.
 *
 * Extrait de la page article pour être réutilisé par la page projet — même
 * document, mêmes extensions, même CSS `.tiptap-readonly`.
 */
export default function RichContent({ content, className = "" }) {
    const editor = useEditor({
        extensions: createReadOnlyExtensions(),
        content: parseTiptapContent(content),
        editable: false,
    });

    useEffect(() => {
        if (!editor || content === undefined) return;

        const next = parseTiptapContent(content);
        if (JSON.stringify(editor.getJSON()) !== JSON.stringify(next)) {
            editor.commands.setContent(next);
        }
    }, [content, editor]);

    // Les images mortes du contenu retombent sur le placeholder de marque.
    useEffect(() => {
        if (!editor) return undefined;
        return attachImageFallback(editor.view.dom);
    }, [editor]);

    if (!editor) return null;

    return (
        <div className={`tiptap-readonly ${className}`.trim()}>
            <EditorContent editor={editor} />
        </div>
    );
}
